export default __webpack_public_path__ + "static/media/center.89859bdc.svg";